<div class="main_content px-3 position-relative">
    <div class="container-fluid">
      <!-- Title Section -->
      <div class="title mb-4">
        <h3>Stats</h3>
      </div>
  
      <!-- Stats Section -->
      <div class="d-flex w-100 justify-content-start mb-4">
        <!-- Last 24 hours unique visits -->
        <div class="white_box shadow p-4 w-45 d-flex flex-column justify-content-center align-items-center mr-4">
          <h5>Last 24 hours unique visits:</h5>
          <p class="count-text">{{ last24HoursVisitCount[0].count }}</p>
        </div>
  
        <!-- Selected Date Section -->
        <div class="white_box shadow p-4 w-45">
          <h5>Selected Date Stats</h5>
          <div *ngIf="dateSelected; else noDate">
            <p><strong>Selected Date:</strong> {{ dateSelected }}</p>
            <p><strong>Count:</strong> {{ countOnSelectedDate || 'No data. Please select another date.' }}</p>
          </div>
          <ng-template #noDate>
            <p>No data. Please select a date.</p>
          </ng-template>
  
          <!-- Date Picker -->
          <div class="mt-3">
            <label for="date-picker" class="form-label">Select date to see count:</label>
            <input id="date-picker" type="date" (change)="seeCountsOn($event)" class="form-control"/>
          </div>
        </div>
      </div>
  
  
      <div class="chart mb-4 d-flex w-100 justify-content-center ">
        <div>
            <canvas *ngIf="chartData" baseChart width="400" height="400" chartType="line"
            [data]="chartData"
            [labels]="chartLabels"
            [options]="chartOptions"
            ></canvas>
        </div>
      
      </div>
    </div>
  </div>
  